<template>
  <div>
    <CollapseItems
      title-class-header="h6"
      title-weight-header="bold"
    >
      <template #title>
        <h5 class="font-weight-black">
          Instruções
        </h5>
      </template>
      <template #content>
        <div class="border-bottom p-4 bg-light text-black-50">
          <p class="mb-1 font-weight-bolder">
            Estamos preparando o  {{ selectedCycle.cycle_name }} personalizado para você.
          </p>
          <p class="mb-1">
            Listamos abaixo {{ selectionModules.length }} módulos de estudos importantes para o seu aprendizado.
            <strong>Escolha {{ selectedCycle.modules_quantity }} deles.</strong>
          </p>
          <p class="mb-4">
            Para te ajudar, criamos um indicador para cada elemento. Quanto mais
            <span class="d-inline-flex">
              <span class="level-bar nitro" />
              <span class="level-bar nitro" />
              <span class="level-bar nitro" />
            </span>
            , mais indicado para você.
          </p>
          <div>
            <p class="font-weight-bold d-flex align-items-center">
              Quando um módulo for destaque para sua trilha do conhecimento, ele terá a marcação:
              <v-icon color="nitro">
                fas fa-star
              </v-icon>
            </p>
          </div>
          <p class="mb-1">
            <strong>Incidência ENEM:</strong> o quanto o módulo está sendo indicado pela incidência no Enem.
          </p>
          <p class="mb-1">
            <strong>Impacto na nota:</strong> o quanto o módulo está sendo indicado pelo potencial de aumentar sua nota TRI.
          </p>
        </div>
      </template>
    </CollapseItems>
    <div class="p-4 text-black border-bottom d-flex flex-sm-row flex-column justify-content-md-between">
      <div class="d-flex align-center justify-content-center justify-content-sm-start">
        <span class="font-weight-bolder">
          {{ selectedCycle.cycle_name }} :
        </span>
        {{ $moment(selectedCycle.begin).format('DD/MM/YYYY') }} a {{ $moment(selectedCycle.end).format('DD/MM/YYYY') }}
      </div>
      <div>
        <ChangeFavoriteLanguage />
      </div>
    </div>
  </div>
</template>
<script>
import CollapseItems from "@/common/components/CollapseItems.vue";
import { mapGetters } from 'vuex';
import ChangeFavoriteLanguage from "@/student/components/ChangeFavoriteLanguage";


export default {
  components: {
    CollapseItems,
    ChangeFavoriteLanguage
  },
  computed: {
    ...mapGetters([
      'selectedCycle',
      'selectionModules',
    ]),
  }
}
</script>
